(function (window, document, $) {
    $(() => {
        const $body = $('body'),
            customClass = 'yco-header--scrolled',
            controlPoint = 30;

        if (!$body.length) {
            return;
        }

        $(document).scroll(function () {
            if ($(document).scrollTop() > controlPoint) {
                if (!$body.hasClass(customClass)) {
                    $body.addClass(customClass);
                }
            } else {
                if ($body.hasClass(customClass)) {
                    $body.removeClass(customClass);
                }
            }
        });
    });
})(window, document, jQuery);



// WEBPACK FOOTER //
// ./assets/scripts/header.js